import React, { FC } from 'react';
import { IonContent } from '@ionic/react';
import DefaultBuyGiftCardModal from '../../../../modals/buy-gift-card/BuyGiftCardModal';
import { GenericModalProps } from '../../../../services/exports/Interfaces';
import { IModal } from '../../router/ModalRouter';

const BuyGiftCardModal: FC<Partial<GenericModalProps & IModal>> = (props) => {
  return (
    <IonContent className="min-h-[90dvh]">
      <DefaultBuyGiftCardModal {...props} />
    </IonContent>
  );
};

export default BuyGiftCardModal;
